/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { ReactNode } from 'react';
import { useAuth } from '../../../hooks/auth';

import HeaderDelivery from '../../../components/HeaderDelivery';
import MenuDelivery from '../../../components/MenuDelivery';
import { Container, Content } from './styles';

interface SiteProps {
  children: ReactNode;
}

export default function DeliveryManLayout({ children }: SiteProps) {
  const { user, signOut } = useAuth();

  if (user.role !== 'DELIVERYMAN') {
    signOut();
  }

  if (user.role !== 'DELIVERYMAN') {
    return <div />;
  }

  window.scrollTo(0, 0);

  return (
    <Container>
      <HeaderDelivery />
      <Content>
        <MenuDelivery />
        {children}
      </Content>
    </Container>
  );
}
